<!--
 * @Author: xuqing6@hikvison.com.cn
 * @Date: 2018-11-20 15:27:47
 * @LastEditors: dongwenjuan@hikvison.com.cn
 * @LastEditTime: 2019-07-11 10:21:49
 -->

<template>
  <el-dialog
    title="欢迎来到萤石商业智居"
    visible
    top="180px"
    class="login-step"
    width="700px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    center
  >
    <div class="step-radio-container step-radio-container__4">
      <p class="container-info">您已是萤石开发者用户，请输入您的Secret</p>
      <div class="step-radio-container__gray">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="add-appInfo-form"
        >
          <el-form-item prop="appKey" label-width="70px" label="AppKey">
            <el-input
              type="text"
              v-model="ruleForm.appKey"
              auto-complete="off"
              placeholder="请输入AppKey"
              prop="appKey"
              @submit.native.prevent
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item prop="appSecret" label-width="70px" label="Secret">
            <el-input
              type="text"
              v-model="ruleForm.appSecret"
              auto-complete="off"
              placeholder="请输入Secret"
              prop="appSecret"
              @submit.native.prevent
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="next-container">
        <el-button type="primary" class="saasl-btn login-next-btn" @click="surePerfectInfo">进入萤石云</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
/* eslint-disable */
import { loginProvider } from "../../api/index";
export default {
  data() {
    const validateAppkey = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入AppKey"));
      } else if (/\s/.test(value)) {
        callback(new Error("不能包含空格"));
      } else {
        callback();
      }
    };
    const validateSecret = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入Secret"));
      } else if (/\s/.test(value)) {
        callback(new Error("不能包含空格"));
      } else {
        callback();
      }
    };
    return {
      checkedValue: 1,
      ruleForm: {
        appKey: "",
        appSecret: ""
      },
      rules: {
        appKey: [
          {
            validator: validateAppkey,
            required: true,
            trigger: ["blur"]
          }
        ],
        appSecret: [
          {
            validator: validateSecret,
            required: true,
            trigger: ["blur"]
          }
        ]
      }
    };
  },
  mounted() {
    this.ruleForm.appKey = this.$ls.get("saas-appKey");
  },
  methods: {
    handleClose() {
      this.gotoLogin();
    },
    gotoLogin() {
      this.$router.push(
        `/login?redirect_uri=${this.$route.query.redirect_uri || ""}`
      );
    },
    surePerfectInfo() {
      this.sureLoading = true;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          loginProvider
            .perfectEnterpriseInfo({
              ...this.$ls.get("enterpriseInfo"),
              appKey: this.ruleForm.appKey,
              appSecret: this.ruleForm.appSecret
            })
            .then(res => {
              this.sureLoading = false;
              if (res && parseInt(res.code) === 200) {
                this.$toast({
                  type: "success",
                  message: "成功",
                  onClose: () => {
                    this.gotoLogin();
                  }
                });
              } else {
                this.$toast({
                  type: "error",
                  message: res.msg || "失败"
                });
              }
            })
            .catch(err => {
              this.sureLoading = false;
              this.$toast({
                type: "error",
                message: err.msg || err.message || "失败"
              });
            });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.saasl-register-step2 {
  padding-top: 50px;
}
.login-step-title {
  color: #000;
  margin-bottom: 20px;
  text-align: center;
}
.login-step {
  .el-dialog__body {
    padding: 25px 50px 25px;
  }
  .saasl-register-step2_form .saasl-register-protocol {
    padding-left: 106px;
    padding-top: 0px;
    padding-bottom: 10px;
  }
  button.el-button.saasl-btn.saasl-home__btn.saasl-register-step2_btn.el-button--default {
    margin-left: 106px;
  }
  .next-container {
    width: 470px;
    display: flex;
    .login-next-btn {
      flex: 1;
      margin-top: 20px;
      &.cancel {
        background-color: #fff;
        border: 1px solid #dddddd;
        color: #333333;
        box-shadow: none;
        &:hover {
          box-shadow: 0px 0px 12px rgba(82, 119, 254, 0.4);
        }
      }
    }
  }
}
.step-radio-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  &.step-radio-container__4 {
    .step-radio-container__gray {
      width: 470px;
      padding: 25px 0 0px 0;
      margin-top: 20px;
    }
    .container-info {
      font-size: 14px;
      color: #3d4060;
      letter-spacing: 0;
      text-align: center;
      margin-top: -20px;
    }
  }
  .add-appInfo-form {
    width: 400px;
    margin: 0 auto;
    .el-input {
      width: 100%;
    }
  }
  .step-radio-container__gray {
    background: #f8f8f8;
    margin: 0 auto;
  }
}
.radio-group {
  .radio-group__left {
    position: relative;
    line-height: 30px;
  }
  input[type="radio"] {
    width: 20px;
    height: 20px;
    opacity: 0;
  }
  label {
    position: absolute;
    left: 5px;
    top: 3px;
    width: 20px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #dadada;
  }
  input:checked + label {
    background-color: #95d02e;
    border: 1px solid #95d02e;
  }
  input:checked + label::after {
    position: absolute;
    content: "";
    width: 5px;
    height: 10px;
    top: 3px;
    left: 6px;
    border: 2px solid #fff;
    border-top: none;
    border-left: none;
    transform: rotate(45deg);
  }
  display: flex;
  width: 470px;
  height: 83px;
  background-color: #f8f8f8;
  margin-bottom: 20px;
  padding-left: 70px;
  padding-top: 20px;
  cursor: pointer;
  .radio-group__left {
    width: 50px;
  }
  .radio-group__right {
    flex: 1;
    font-size: 14px;
    color: #929398;
    p {
      line-height: 24px;
    }
    .radio-group__right--top {
      color: #333333;
    }
    .span__blue {
      color: #458fff;
    }
  }
}
</style>
